module.exports = __webpack_public_path__ + "static/media/health2.38bdac44.png";